export default __webpack_public_path__ + "static/media/vehelix_download_01.403ce241.svg";